import Leaflet from 'leaflet';
export var buildPopup = function buildPopup(markerData, popupContentConstructor) {
  var popup = Leaflet.popup({
    autoPan: false
  }).setContent(function () {
    return popupContentConstructor(markerData);
  });
  return popup;
};
export default {
  buildPopup: buildPopup
};